export default __webpack_public_path__ + "static/media/SRL-Telematics.2ee26813.png";